// @flow
import * as React from 'react';
import { Provider as ReduxProvider, type Store } from 'react-redux';

import ReactAppContext from 'Context/ReactAppContext';
import { ReactPageContext } from 'Context/pageContext';
import { ToastContext } from 'Context/ToastContext';
import { routerContext } from 'Client/router/routerContext';
import { ResponsiveLayout } from 'Components/utils/responsive/ResponsiveLayout.jsx';
import { ResortListProvider } from 'Context/ResortListProvider.jsx';
import DepartureCitiesProvider from 'Context/DepartureCitiesProvider.jsx';
import AbTestProvider from 'Context/ABTestProvider';

type Props = {|
  children: React.Node,
  appContext: AppContext,
  pageContext: PageContext,
  reduxStore: Store<ReduxState>,
  routerContextValue: RouterContext<UrlParams, QueryParams>,
  toastRef?: { current: ?HTMLElement },
|};
export const AppProviders = ({
  children,
  appContext,
  pageContext,
  reduxStore,
  routerContextValue,
  toastRef,
}: Props) => (
  <ReactAppContext.Provider value={appContext}>
    <ReactPageContext.Provider value={pageContext}>
      <ReduxProvider store={reduxStore}>
        <AbTestProvider>
          <routerContext.Provider value={routerContextValue}>
            <ResponsiveLayout userAgent={appContext.userAgent}>
              <DepartureCitiesProvider>
                <ResortListProvider>
                  <ToastContext.Provider value={{ ref: toastRef }}>
                    {children}
                  </ToastContext.Provider>
                </ResortListProvider>
              </DepartureCitiesProvider>
            </ResponsiveLayout>
          </routerContext.Provider>
        </AbTestProvider>
      </ReduxProvider>
    </ReactPageContext.Provider>
  </ReactAppContext.Provider>
);
